import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
    selector: 'app-action-url-chat-bubble',
    templateUrl: './action-url-chat-bubble.component.html',
    styleUrls: ['./action-url-chat-bubble.component.scss']
})
export class ActionUrlChatBubbleComponent implements OnInit {

  @Input() content;
  public body: any;
  public footer: any;
  public text: any;
  public title: any;
  public url: any;

  constructor(public sanitization: DomSanitizer) {}
  ngOnInit() {
    if (this.content && this.content.actionUrl) {
      const actionUrlData = this.content.actionUrl;

      this.body = actionUrlData.body || '';
      this.footer = actionUrlData.footer || '';
      this.text = actionUrlData.header?.text || '';
      this.title = actionUrlData.title || '';
      this.url = actionUrlData.url || '';
    } else {
      console.error('Invalid content structure:', this.content);
    }
  }

  openUrl() {
    let targetUrl = this.url?.trim();

    if (targetUrl && !/^https?:\/\//i.test(targetUrl)) {
      targetUrl = `https://${targetUrl}`;
    }

    window.open(encodeURI(targetUrl), '_blank');
  }
}
